import { ShieldCheck, Lock, RotateCcw } from "lucide-react";
import vivaLogo from "@/assets/payments/viva.webp";
import klarnaLogo from "@/assets/payments/klarna.webp";
import irisLogo from "@/assets/payments/iris.webp";

const PAYMENTS = [
  { src: vivaLogo, alt: "Viva.com — ασφαλείς πληρωμές με κάρτα" },
  { src: irisLogo, alt: "IRIS — άμεση τραπεζική πληρωμή" },
  { src: klarnaLogo, alt: "Klarna — πληρωμή σε δόσεις" },
];

const SECURITY = [
  { icon: Lock, label: "Ασφαλείς συναλλαγές SSL" },
  { icon: ShieldCheck, label: "Προστασία αγορών" },
  { icon: RotateCcw, label: "Εύκολες επιστροφές" },
];

/**
 * Σήματα ασφαλείας + λογότυπα τρόπων πληρωμής (Viva, IRIS, Klarna), για χρήση
 * σε εμφανή σημεία (footer & checkout) ώστε να ενισχύεται η εμπιστοσύνη.
 */
export function TrustBadges({ className = "", compact = false }: { className?: string; compact?: boolean }) {
  return (
    <div className={`${className}${compact ? " flex flex-col items-center justify-center gap-2 lg:flex-row lg:gap-6" : ""}`}>
      <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
        {SECURITY.map(({ icon: Icon, label }) => (
          <span
            key={label}
            className="inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground"
          >
            <Icon className="h-4 w-4 text-success" aria-hidden /> {label}
          </span>
        ))}
      </div>
      <div className={`${compact ? "" : "mt-3 "}flex flex-wrap items-center justify-center gap-3`}>
        {PAYMENTS.map(({ src, alt }) => (
          <span
            key={alt}
            className={`grid ${compact ? "h-9 w-20 rounded-md px-2 py-1" : "h-12 w-24 rounded-xl px-3 py-2"} place-items-center overflow-hidden border border-border bg-card shadow-sm`}
          >
            <img
              src={src}
              alt={alt}
              width={88}
              height={32}
              loading="lazy"
              className={`${compact ? "max-h-6" : "max-h-8"} max-w-full object-contain`}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
